    import { fetch } from '../../services/api';
import QueryBuilder from '../../components/WHTable/queryBuilder';

const endPoints = '/api/posts';

export const search = (data) => {

    let query = QueryBuilder(data);

    query.transaction = {type : 3};

    return fetch(endPoints, query, 'get')

};

export const view = (id) => fetch(`${endPoints}/${id}`, 'get');

export const create = (data) => fetch(`${endPoints}`, data, 'post');

export const update = (data) => fetch(`${endPoints}/${data.id}`, data, 'put');

export const remove = (id) => fetch(`${endPoints}/${id}`, {}, 'delete');

export const getParams = () => fetch(`${endPoints}/params`, {}, 'get');


export const terreNetPost = () => {
  return fetch(`${endPoints}?terreNetId[exists]=1&published=1`, {}, 'get')
};

export const otherPosts = () => {
  return fetch(`${endPoints}?terreNetId[exists]=0&published=1`, {}, 'get')
};


// WEBPACK FOOTER //
// ./src/services/post/index.js